module.exports = __webpack_public_path__ + "img/reset_step3.90a8e5a5.png";